/* Giorgio header: mega menu + phone drawer. Loaded by sections/giorgio-header.liquid */
/* A flavour link in the menu (?variant=...) is a choice the shopper made.
   giorgio-nodefault-variant.js only counts ?variant= as chosen when the link
   came from ANOTHER page, so a menu click made while already on that product
   opened on "Choose your ... flavor". The click is noted here, and on the
   next page -- before that script runs (both deferred, the header first) --
   it is written as the product's own "picked" flag. "Create Your Own" is left
   alone: it opens straight on the flavour dropdown, as the client wants. */
(function () {
  try {
    var KEY = 'gioNavPick';
    var cfg = window.ggNoDefault;
    if (sessionStorage.getItem(KEY) === '1') {
      sessionStorage.removeItem(KEY);
      if (/[?&]variant=/.test(window.location.search) && cfg && cfg.productId) {
        sessionStorage.setItem('ggPicked:' + cfg.productId, '1');
      }
    }
    document.addEventListener('click', function (e) {
      var a = e.target && e.target.closest && e.target.closest('[data-gh] a[href*="variant="], [data-gh-drawer] a[href*="variant="]');
      if (a && !/create your own/i.test(a.textContent)) { try { sessionStorage.setItem(KEY, '1'); } catch (x) {} }
    }, true);
  } catch (e) {}
})();
(function () {
  var root = document.querySelector('[data-gh]');
  var drawer = document.querySelector('[data-gh-drawer]');
  if (!root || root.__gh) return;
  root.__gh = true;
  /* ---- desktop mega menu ---- */
  var hoverable = window.matchMedia('(hover: hover) and (pointer: fine)');
  var items = [].slice.call(root.querySelectorAll('.gh-item'));
  var timer;
  var isHome = root.classList.contains('gh--overlay');
  function setSolid() {
    if (!isHome) return;
    var on = root.matches(':hover') || !!root.querySelector('.gh-item.is-open') || root.contains(document.activeElement) || !!root.querySelector('details[open]');
    root.classList.toggle('is-solid', on);
  }
  function closeAll() {
    items.forEach(function (li) {
      li.classList.remove('is-open');
      var a = li.querySelector('.gh-link');
      if (a.hasAttribute('aria-expanded')) a.setAttribute('aria-expanded', 'false');
    });
    setSolid();
  }
  function openItem(li) {
    items.forEach(function (x) { if (x !== li) { x.classList.remove('is-open'); var a = x.querySelector('.gh-link'); if (a.hasAttribute('aria-expanded')) a.setAttribute('aria-expanded', 'false'); } });
    if (li.querySelector('.gh-mega')) {
      li.classList.add('is-open');
      li.querySelector('.gh-link').setAttribute('aria-expanded', 'true');
    }
    setSolid();
  }
  items.forEach(function (li) {
    var a = li.querySelector('.gh-link');
    li.addEventListener('mouseenter', function () { if (!hoverable.matches) return; clearTimeout(timer); timer = setTimeout(function () { openItem(li); }, 90); });
    li.addEventListener('mouseleave', function () { if (!hoverable.matches) return; clearTimeout(timer); timer = setTimeout(closeAll, 160); });
    a.addEventListener('click', function (e) {
      if (!li.querySelector('.gh-mega')) return;
      /* touch screens: first tap opens the panel, second tap follows the link */
      if (!hoverable.matches && !li.classList.contains('is-open')) { e.preventDefault(); openItem(li); }
    });
    a.addEventListener('keydown', function (e) {
      if ((e.key === 'Enter' || e.key === ' ' || e.key === 'ArrowDown') && li.querySelector('.gh-mega') && !li.classList.contains('is-open')) { e.preventDefault(); openItem(li); }
    });
  });
  root.addEventListener('focusout', function () { setTimeout(function () { if (!root.contains(document.activeElement)) closeAll(); }, 0); });
  root.addEventListener('mouseenter', setSolid);
  root.addEventListener('mouseleave', function () { setTimeout(setSolid, 180); });
  root.addEventListener('toggle', setSolid, true);
  document.addEventListener('click', function (e) { if (!root.contains(e.target)) closeAll(); });
  /* the word "Search" opens the same search panel as the icon */
  var label = root.querySelector('.gh-search-label');
  if (label) label.addEventListener('click', function () { var s = root.querySelector('.gh-search summary'); if (s) s.click(); });
  /* ---- small-screen drawer ---- */
  var opener = root.querySelector('[data-gh-open]');
  function openDrawer() {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    opener.setAttribute('aria-expanded', 'true');
    document.documentElement.classList.add('gh-lock');
    var c = drawer.querySelector('.gh-close'); if (c) c.focus();
  }
  function closeDrawer() {
    if (!drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    opener.setAttribute('aria-expanded', 'false');
    document.documentElement.classList.remove('gh-lock');
    opener.focus();
  }
  opener.addEventListener('click', openDrawer);
  [].forEach.call(drawer.querySelectorAll('[data-gh-close]'), function (b) { b.addEventListener('click', closeDrawer); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeAll(); closeDrawer(); } });
  /* the bag icon opens the cart drawer when the theme has one */
  var bag = drawer.querySelector('[data-gh-bag]');
  if (bag) bag.addEventListener('click', function (e) {
    if (!document.querySelector('cart-drawer')) return;
    e.preventDefault(); closeDrawer();
    var icon = document.getElementById('cart-icon-bubble'); if (icon) icon.click();
  });
  [].forEach.call(drawer.querySelectorAll('[data-gh-tab]'), function (tab) {
    tab.addEventListener('click', function () {
      [].forEach.call(drawer.querySelectorAll('[data-gh-tab]'), function (t) { t.setAttribute('aria-selected', t === tab ? 'true' : 'false'); });
      [].forEach.call(drawer.querySelectorAll('[data-gh-pane]'), function (p) { p.hidden = p.getAttribute('data-gh-pane') !== tab.getAttribute('data-gh-tab'); });
    });
  });
  /* + / − rows: one open at a time within each list */
  [].forEach.call(drawer.querySelectorAll('.gh-m-item > button.gh-m-top'), function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.parentNode;
      var list = item.parentNode;
      var willOpen = !item.classList.contains('is-open');
      [].forEach.call(list.children, function (x) {
        if (x.classList && x.classList.contains('is-open')) { x.classList.remove('is-open'); var b = x.querySelector('.gh-m-top'); if (b) b.setAttribute('aria-expanded', 'false'); }
      });
      if (willOpen) { item.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true'); }
    });
  });
  window.matchMedia('(min-width: 990px)').addEventListener('change', function (m) { if (m.matches) closeDrawer(); });
})();